import tracking from '../../utils/tracking';

export default class HealthMonitor {
  params: any;
  firstPages: any;
  lastPages: any;
  categories: any;
  ratingTypes: any;
  labels: any;
  monthMap: any;
  countdownInitialScreen: any;
  countdownFinalScreen: any;
  urlParams: { n: number; };
  prevPage: number;
  prevHash: string;
  sequence: any[];
  resultsInfo: any;
  modalMonitor: HTMLDivElement;
  typingTimeoutId: any;
  additionalTrackingProperties: any;
  additionalTrackingSchema: any;

  constructor(_domRoot: HTMLElement, params: any) {
    this.params = params;
    this.firstPages = params.firstPages;
    this.lastPages = params.lastPages;
    this.categories = params.categories;
    this.ratingTypes = params.ratingTypes;
    this.labels = params.labels;
    this.monthMap = params.monthMap;
    this.countdownInitialScreen = params.countdownInitialScreen;
    this.countdownFinalScreen = params.countdownFinalScreen;
    this.urlParams = {n: -1};
    this.prevPage = -1;
    this.prevHash = "";
    this.sequence = [];
    this.resultsInfo = {};
    this.modalMonitor = document.createElement("div");
    this.typingTimeoutId;
    this.additionalTrackingProperties = {}; 
    this.additionalTrackingSchema = {
      'schemaVersion': '1',
      'eventType' : 'Track',
      'eventContainer' : 'page',
      'eventColumn' : null,
      'eventComponent' : 'button',
      'magnoliaComponentId' : null,
      'event' : 'clicked',
      'inputValue' : null,
      'parentLabel' : 'Health Monitor',
      'label' : null,
      'productKey' : null,
      'productVersion' : null,
      'productEdition' : null,
      'productPlatform': null,
    };
    this.init();
  }

  init() {
    var self = this;
    document.body.appendChild(this.modalMonitor);
    this.resultsInfo = {};
    self.renderPage();
    
    window.onhashchange = function() {
      self.renderPage();
    }
    window.addEventListener("click", function(e) {
      if (e.target.id === "copy-link") {
        let shareURL = document.getElementById("copy-text");
        shareURL.select();
        document.execCommand("copy");
        e.target.className += " copy-success";
      } else if (e.target.className.indexOf("start-countdown") > -1) {
        self.startCountdown();
      } else if (e.target.className.indexOf("stop-countdown") > -1) {
        var voteContainer = document.getElementById("count-vote");
        self.modalMonitor.removeChild(voteContainer);
      } else if (e.target.className.indexOf("prev-link") > -1) {
        window.location.hash = self.getHashURL({increment: -1});
      } else if (e.target.className.indexOf("next-link") > -1) {
        window.location.hash = self.getHashURL({increment: 1});
      } else if (e.target.className.indexOf("retreat") > -1) {
        self.resultsInfo.sumPage = self.urlParams.n;

      } else if (e.target.className.indexOf("question-link") > -1) {
        if (self.resultsInfo.sumPage) {
          setTimeout(function() {
            window.location.hash = self.getHashURL({toPage: self.resultsInfo.sumPage});
          }, 100);
        }
        
      }

      if (e.target.hasAttribute("data-track-event")) {
        const dataTrackEventAttributeName = e.target.getAttribute("data-track-event");
        tracking.trackEvent(dataTrackEventAttributeName, tracking.sanitizeEventProperties(self.additionalTrackingProperties[dataTrackEventAttributeName]));
      }

    });
    window.addEventListener("change", function(e) {
      if (e.target.hasAttribute("data-results")) {
        self.resultsInfo[e.target.getAttribute("data-results")] = e.target.checked;
        self.renderPage();
      }
    });
    window.addEventListener("keyup", function(e) {
      if (e.target.hasAttribute && e.target.hasAttribute("data-text")) {
        var textKey = e.target.getAttribute("data-text");
        var cleanedString = self.cleanString(e.target.value);
        self.urlParams[textKey] = encodeURIComponent(cleanedString);
        e.target.value = cleanedString;
        window.history.pushState({}, null, self.getHashURL({}));
        if (e.target.hasAttribute("data-track-event")) {
          const dataTrackEventAttributeName = e.target.getAttribute("data-track-event");
          // Track user entered data
          clearTimeout(self.typingTimeoutId);
          self.typingTimeoutId = setTimeout(function(){
            const additionalTrackingProp = { ...self.additionalTrackingProperties[dataTrackEventAttributeName], ...{'event': 'keyup', 'inputValue': self.urlParams[textKey]}};
            tracking.trackEvent(dataTrackEventAttributeName,tracking.sanitizeEventProperties(additionalTrackingProp));
          }, 500);
        }
      }
    }, true)
  }

  isNumber(num) {
    return !isNaN(num);
  }

  getHashURL(options) {
    /*
    c = category
    n = page number
    tn = team name
    q[i] = question[index] answer
    t[i] = question[index] action item
    */
    var urlString = "#m";
    var increment = 0;
    var pageNum = this.urlParams.n;
    
    var stringHash = JSON.parse(JSON.stringify(this.urlParams))
    if (options.questions) {
      for (var o in options.questions) {
        stringHash[o] = options.questions[o];
      }
    }
    if (this.isNumber(options.category)) {
      stringHash.c = Number(options.category);
    }
    if (this.isNumber(options.increment)) {
      increment = options.increment;
    }
    if (this.isNumber(options.toPage)) {
      pageNum = Number(options.toPage);
    }
    
    for (var k in stringHash) {
      urlString += ";" + k + ":";
      if (k.indexOf("q") === 0) {
        urlString += Number(stringHash[k]);
      } else if (k === "n"){
        urlString += (pageNum + increment);
      } else {
        urlString += stringHash[k];
      }
    }

    return urlString;
  }

  cleanString(string) {
    return string
    .replace(/[^\w\s\-\.,'’]/g, '')
    .replace(/'/g, "’")
    .substring(0, 140);
  }

  setURLtoObject() {
    this.prevPage = this.urlParams.n;

    var params = window.location.hash.replace("#m", "").split(";");
    for (var i in params) {
      var param = params[i].split(":");
      if (param[1] && param[1].length) {
        this.urlParams[param[0]] = param[0].indexOf("t") === -1 ? Number(param[1]) : this.cleanString(decodeURIComponent(param[1]));
      }
    }
    if (!this.urlParams.td) {
      var newDate = new Date();
      this.urlParams.td = newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate();
    }
  }

  startCountdown() {
    if (document.getElementById("count-vote") === null) {
      var countdownContainer = document.createElement("div");
      var secondsTilVoteScreenDisappears = 3;
      var countDownFromX = this.params.countdownInitialScreen.counts.length;
      
      this.modalMonitor.appendChild(countdownContainer);
      countdownContainer.id = "count-vote";
      var self = this;

      const stopVoteCountDownDataTrackEvent = "Health Monitor - Vote - StopCountdown";
      this.additionalTrackingProperties[stopVoteCountDownDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
        'eventContainer' : 'countDown',
        'eventComponent' : 'closeButton',
      } };

      const delayTimeout = function(s, countDownFromX, secondsTilVoteScreenDisappears) {
        setTimeout(function() {
          if (s === countDownFromX) {
            countdownContainer.innerHTML = `<button class="close-button-link stop-countdown" data-track-event="${stopVoteCountDownDataTrackEvent}">&times;</button> ${self.params.countdownFinalScreen}`;
          } else if (s < countDownFromX) {
            countdownContainer.innerHTML = `<button class="close-button-link stop-countdown" data-track-event="${stopVoteCountDownDataTrackEvent}">&times;</button>
              ${self.params.countdownInitialScreen.preContent}
              ${self.params.countdownInitialScreen.counts[s]}
              ${self.params.countdownInitialScreen.postContent}`;
          } else if (s === countDownFromX + secondsTilVoteScreenDisappears) {
            self.modalMonitor.removeChild(countdownContainer);
          }
        }, 1000 * s);
      }

      for (var s = 0; s <= countDownFromX + secondsTilVoteScreenDisappears; s++) {
        delayTimeout(s, countDownFromX, secondsTilVoteScreenDisappears)
      }
    }
  }

  renderPage() {
    this.setURLtoObject();
    this.sequence = [];
    var sequenceQuestionsIndex = this.urlParams.c;
    if (isNaN(this.urlParams.c)) {
      sequenceQuestionsIndex = 0;
    }

    this.sequence = this.sequence.concat(this.firstPages, this.categories[sequenceQuestionsIndex].questions, this.lastPages);



    if (window.location.hash.indexOf("#m") === 0 && this.sequence[this.urlParams.n] && this.sequence[this.urlParams.n].pageIdentifier) {
      var thisContent = this.sequence[this.urlParams.n];

      const previousButtonDataTracking = thisContent.previousDataTrackEvent ? thisContent.previousDataTrackEvent : "Health Monitor - Previous";
      const nextButtonDataTracking = thisContent.nextDataTrackEvent ? thisContent.nextDataTrackEvent : "Health Monitor - Next";

      // Adding to tracking dictionary for look up later.
      this.additionalTrackingProperties[previousButtonDataTracking] = { ...this.additionalTrackingSchema, ...{
        'label' : this.labels.previous
      } };

      this.additionalTrackingProperties[nextButtonDataTracking] = { ...this.additionalTrackingSchema, ...{
        'label' : thisContent.nextLabel
      } };

      var htmls = `<a class="close-button-link close-all" href="#">&times;</a><div class="intra-flex">`;
      if (thisContent.content) {
        htmls += thisContent.content.replace(/{{teamLabel}}/g, this.urlParams.tn ? decodeURIComponent(this.urlParams.tn) : "");
      }

      if (thisContent.pageIdentifier !== "default" && this[thisContent.pageIdentifier] ) {
        htmls += `<div class="container"><div class="row reduced-row flex-container md-none-top">${this[thisContent.pageIdentifier]()}</div></div>`;
      }
      
      htmls += `</div>
      <div class="container nav-fixed">
        <div class="navigation row reduced-row">
          <div class="column inner">`;

      if (this.urlParams.n < this.sequence.length - 1) {
        var buttonClass = "secondary";
        if (thisContent.pageIdentifier === "question") {
          var questionId = this.urlParams.n - this.firstPages.length;
          if (this.isNumber(this.urlParams["q" + questionId])) {
            buttonClass = "primary";
          }
        }
        htmls += `
          <button class="prev-link button--one button--small button--secondary" data-track-event='${previousButtonDataTracking}'>
          ${this.labels.previous}
          </button>
          <div class="progress-bar">
            <div class="progress" style="width: ${((this.urlParams.n + 1) / this.sequence.length) * 100}%;"></div>
          </div>
          <button class="next-link button button--one button--small button--${buttonClass}" ${thisContent.pageIdentifier === "choose" && isNaN(this.urlParams.c) ? ` disabled` : ``} data-track-event='${nextButtonDataTracking}'>
            ${thisContent.nextLabel}
          </button>`;
      }

      htmls += `</div></div></div>`;
      
      document.body.style.overflow = "hidden";
      this.modalMonitor.className = "n0 component--modal-monitor";
      this.modalMonitor.innerHTML = htmls;

      // For the very last page. Assume this is the very last page
      // Doing this because of data tracking requirements
      if(this.urlParams.n === this.sequence.length - 1 ) {
        let index;
        const closeAndExplorePlaysInnerText = ['close', 'explore plays'];
        const finalDataTrackEventLabel = (value) => `Health Monitor - last page - ${value.trim().toLowerCase()}`;
        const addfinalDataTrackingEvent = (dataTrackEventName, label) => (
          this.additionalTrackingProperties[dataTrackEventName] = { ...this.additionalTrackingSchema, ...{
            'label': label,
            'eventContainer' : 'final',
            'eventComponent' : 'button',
          }}
        );

        // get a list of buttons on page. we want specifically the close and explore plays button
        const listOfButtons = document.getElementsByClassName('button');
        for (index = 0; index < listOfButtons.length; index++) {
          const elementInnerText = listOfButtons[index].innerText.trim().toLowerCase();
          if (closeAndExplorePlaysInnerText.includes(elementInnerText)) {
            if (listOfButtons[index].hasAttribute("data-track-event")) {
              addfinalDataTrackingEvent(listOfButtons[index].getAttribute("data-track-event"), elementInnerText);
            } else {
              const trackingEventLabel = finalDataTrackEventLabel(elementInnerText);
              // add event to tracking look up
              addfinalDataTrackingEvent(trackingEventLabel, elementInnerText);
              // add tracking event to button
              listOfButtons[index].setAttribute('data-track-event', trackingEventLabel);
            }
          }
        }
      }

    } else {
      this.urlParams = {n: -1};
      this.resultsInfo = {};
      document.body.style.overflow = "auto";
      this.modalMonitor.className = "";
      this.modalMonitor.innerHTML = "";
    }
    if (this.urlParams.n !== this.prevPage) {
      this.modalMonitor.scrollTop = 0;
    }
  }

  /* the below functions are named for page identifiers specified in the "pageIdentifier" field dialog */
  /* these are used if that particular health monitor page requires custom behavior beyond what is inputtable in magnolia */

  results() {
    let dateBits = this.urlParams.td.split('-');
    let dateYear = Number(dateBits[0]);
    let dateMonth = Number(dateBits[1]) - 1;
    let dateDay = Number(dateBits[2]);
    var date = new Date(dateYear, dateMonth, dateDay);
    var resultsHTML = `
      ${this.urlParams.tn ? `<div class="column-md-6 text-right">
        <p><span class="heading h5">
          ${this.labels.teamName}</span> ${decodeURIComponent(this.urlParams.tn)}
        </p></div>` : ""}
    
      <div class="column-md-6  ${this.urlParams.tn ? "" : "column-md-offset-3 text-center"}">
        <p><span class="heading h5">${this.labels.completedOn}</span>
        ${this.monthMap[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}
        </p>
      </div>
    </div>
    <div class="row reduced-row">    
    <div class="column">

    <div class="labels-row hide-sm hide-xs border-row ${this.resultsInfo["q" + r + "highlighted"] ? "highlighted" : ""} ">
      <div class="column column-md-1">
        <h5>${this.labels.select}</h5>
      </div>
      <div class="column column-md-5">
        <h5>${this.labels.attribute}</h5>
      </div>
      <div class="column column-md-3">
        <h5>${this.labels.teamRating}</h5>
      </div>
      <div class="column column-md-3 text-right">
      <h5>${this.labels.details}</h5>
      </div>
    </div>`;
    if (this.isNumber(this.urlParams.c)) {
      for (var r in this.categories[this.urlParams.c].questions) {
        var thisQuestion = this.categories[this.urlParams.c].questions[r];
        var rating = `<div class="rating">`;
        if (isNaN(this.urlParams["q" + r])) {
          const unansweredDataTrackEvent = `Health Monitor - ${this.labels.unanswered.trim()} - ${thisQuestion.title.trim()}`;
          this.additionalTrackingProperties[unansweredDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
            'label': this.labels.unanswered,
            'eventContainer' : 'resultsSummary',
            'eventComponent' : 'link',
            'parentLabel': thisQuestion.title,
          } };


          rating += `<a class="retreat" href="${this.getHashURL({toPage: Number(r) + this.firstPages.length})}" data-track-event='${unansweredDataTrackEvent}'}>
            ${this.labels.unanswered}
          </a>`;
        } else {
          rating += `<img class="align-center" src="${this.ratingTypes[this.urlParams["q" + r]].smallImage}">
          <span>${this.ratingTypes[this.urlParams["q" + r]].shortDescription}</span>`;
        }
        rating += "</div>"

        var suggestedPlays = ``;
        for (var p = 0; p < thisQuestion.plays.length; p++) {
          const suggestedPlayDataTrackEvent = `Health Monitor - suggested plays - ${thisQuestion.title.trim()} - ${thisQuestion.plays[p].title.trim()}`;
          this.additionalTrackingProperties[suggestedPlayDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
            'label': thisQuestion.plays[p].title,
            'magnoliaComponentId': thisQuestion.plays[p].uuid,
            'eventContainer' : 'suggestedPlay',
            'eventComponent' : 'link',
            'parentLabel': thisQuestion.title,
          } };
          suggestedPlays += `<div class="sugg-play"><a href="${thisQuestion.plays[p].url}" data-track-event='${suggestedPlayDataTrackEvent}'>${thisQuestion.plays[p].title}</a></div>`;
        }

          const nextStepPlayDataTrackEvent = `Health Monitor - next steps - ${thisQuestion.title.trim()}`;
          this.additionalTrackingProperties[nextStepPlayDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
            'label': this.labels.nextSteps,
            'eventContainer' : 'resultsSummary',
            'eventComponent' : 'link',
            'parentLabel': thisQuestion.title,
          } };

        resultsHTML += `<div class="${this.resultsInfo["q" + r + "maxed"] ? "no-" : ""}border-row flex-container ${this.resultsInfo["q" + r + "highlighted"] ? "highlighted" : ""} md-compact-top xs-compact-bottom">
          <div class="column column-md-1 hide-sm hide-xs ">
            <input type="checkbox" class="desk-check" data-results="q${r}highlighted" ${this.resultsInfo["q" + r + "highlighted"] ? "checked" : ""}>
          </div>
          <div class="column column-md-5 xs-none-bottom sm-none-bottom">
            <h3>
            <input class="highlight-check hide-md hide-lg hide-xl" type="checkbox" data-results="q${r}highlighted" ${this.resultsInfo["q" + r + "highlighted"] ? "checked" : ""}>

            ${thisQuestion.title}
            <label class="maxer hide-md hide-lg hide-xl" for="maxed${r}">
              <span>${this.resultsInfo["q" + r + "maxed"] ? "-" : "+"}</span>
            </label>
            </h3>
          </div>
          <div class="column column-md-3 xs-none sm-none">
            ${rating}
          </div>
          <div class="column column-md-3 hide-sm hide-xs text-right">
            <input type="checkbox" class="next-step" id="maxed${r}" class="link"
              data-results="q${r}maxed" ${this.resultsInfo["q" + r + "maxed"] ? "checked" : ""}
              data-track-event='${nextStepPlayDataTrackEvent}'
            >
            <label for="maxed${r}">
              ${this.labels.nextSteps}
              <span>${this.resultsInfo["q" + r + "maxed"] ? "-" : "+"}</span>
            </label>
          </div>
        </div>`;

        const actionItemDataTrackEvent = `Health Monitor - action item - ${thisQuestion.title.trim()}`;
        this.additionalTrackingProperties[actionItemDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
          'label': this.labels.actionItems,
          'eventContainer' : 'actionItem',
          'eventComponent' : 'textBox',
        }};

        if (this.resultsInfo["q" + r + "maxed"]) {
          resultsHTML += `<div class="border-row flex-container ${this.resultsInfo["q" + r + "highlighted"] ? "highlighted" : ""}  xs-compact-bottom">
          <div class="column column-md-1 hide-sm hide-xs"></div>
          <div class="column column-md-5 xs-none sm-none">
            <h4>${this.labels.attributeDefinition}</h4>
            <p>${thisQuestion.description}</p>
          </div>
          <div class="column column-md-3 xs-none sm-none">
            <h4>${this.labels.suggestedPlays}</h4>
            ${suggestedPlays}
          </div>
          <div class="column column-md-3 xs-none sm-none">
            <h4>${this.labels.actionItems}</h4>
            <textarea placeholder="${this.labels.addActionItems}" maxlength="100" data-text="t${r}" data-track-event="${actionItemDataTrackEvent}">${this.urlParams["t" + r] ? decodeURIComponent(this.urlParams["t" + r]) : ""}</textarea>
          </div>
        </div>`
        }
      }
    }
    resultsHTML += `</div>`;
    return resultsHTML;
  }

  question() {
    var numQuestions = this.categories[this.urlParams.c].questions.length;
    var thisQuestionIndex = this.urlParams.n - this.firstPages.length;
    var thisQuestion = this.categories[this.urlParams.c].questions[thisQuestionIndex];

    const voteCountDownDataTrackEvent = thisQuestion.voteCountdownDataTrackEvent ? thisQuestion.voteCountdownDataTrackEvent : "Health Monitor - Vote - Countdown";
    this.additionalTrackingProperties[voteCountDownDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
      'label': this.labels.voteCountDown,
      'eventContainer' : 'question',
      'eventComponent' : 'link',
    } };

    var urlOptions = {};
    var questionHTML = `<div class="column column-md-7 column-md-offset-1 text-oversized">
      <h5 class="heading">
        ${this.labels.readQuestionOutLoud}
        (${this.labels.question} ${thisQuestionIndex + 1} ${this.labels.of} ${numQuestions})</h5>
      <h2 class="heading">${thisQuestion.title}</h2>
      <p>${thisQuestion.description}</p>
      <strong class="heading"><a class="heading start-countdown" href="javascript: void(0)" data-track-event='${voteCountDownDataTrackEvent}'>
        ${this.labels.voteCountDown}
      </a></strong>
    </div>
    <div class="column column-md-3">
      <h5>
        ${this.labels.teamRating}
      </h5>
      <h4>
        ${this.labels.selectConsensus}
      </h4>
      <p>
        ${this.labels.keepDiscussionBrief}
      </p>`;
    for (var c in this.ratingTypes) {
      const ratingDataTrackEventimg = `Health Monitor - Vote - ${this.ratingTypes[c].shortDescription} - img`;
      const ratingDataTrackEventButton = `Health Monitor - Vote - ${this.ratingTypes[c].shortDescription} - button`;

      this.additionalTrackingProperties[ratingDataTrackEventimg] = { ...this.additionalTrackingSchema, ...{
        'label': `image for ${this.ratingTypes[c].shortDescription}`,
        'eventContainer' : 'question',
        'eventComponent' : 'image',
      } };

      this.additionalTrackingProperties[ratingDataTrackEventButton] = { ...this.additionalTrackingSchema, ...{
        'label': this.ratingTypes[c].shortDescription,
        'eventContainer' : 'question',
        'eventComponent' : 'button',
      } };

      urlOptions["q" + thisQuestionIndex] = c;
      questionHTML += `<div class="chooser ${this.urlParams["q" + thisQuestionIndex] === c ? "activated" : ""}">
        <a class="image-link" href="${this.getHashURL({questions: urlOptions})}">
          <img class="align-center" src="${this.ratingTypes[c].smallImage}" data-track-event='${ratingDataTrackEventimg}'>
        </a>
        <a href="${this.getHashURL({questions: urlOptions})}" class="question-link component__link button button--one button--small button--secondary" style="border-color: ${this.ratingTypes[c].color}; ${this.urlParams["q" + thisQuestionIndex] == c ? ` background-color: ${this.ratingTypes[c].color}` : ``};" data-track-event='${ratingDataTrackEventButton}'>
          ${this.ratingTypes[c].shortDescription}
        </a>
      </div>`;
    }
    questionHTML += `</div> `;
    return questionHTML;
  }

  choose() {
    var categories = ``;
    
    var colWidth = this.categories.length > 3 || this.categories.length < 3 ? 6 : 4;
    for (var cat = 0; cat < this.categories.length; cat++) {
      const buttonDataTrackEvent = this.categories[cat].dataTrackEvent ? this.categories[cat].dataTrackEvent : `Health Monitor - category - ${this.categories[cat].categoryType}`;
      this.additionalTrackingProperties[buttonDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
        'label': this.categories[cat].categoryType,
        'magnoliaComponentId': this.categories[cat].uuid,
        'eventContainer' : 'category',
        'eventComponent' : 'button',
      } };

      var teamName = ``;
      const teamNameDataTrackEvent = `Health Monitor - category - ${this.categories[cat].categoryType} - team name`;
      this.additionalTrackingProperties[teamNameDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
        'label': this.labels.teamName,
        'eventContainer' : 'category',
        'eventComponent' : 'textBox',
      }};


      if (this.isNumber(this.urlParams.c)) {
        teamName = `<div class="team-name">
          <label>${this.labels.teamName}</label>
          <input data-text="tn" data-track-event="${teamNameDataTrackEvent}" maxlength="30" value="${this.urlParams.tn ? decodeURIComponent(this.urlParams.tn) : ""}"> 
        </div>`;
      }
      categories += `<div class="column column-lg-${colWidth} column-lg-offset-0 column-md-10 column-md-offset-1 ${this.isNumber(this.urlParams.c) && this.urlParams.c != cat ? "inactive" : ""}">
        <div class="block-theme-one category-block">
          ${this.categories[cat].imageEmbed}
          <h5>${this.categories[cat].label ? this.categories[cat].label : "&nbsp;"}</h5>
          <h3>${this.categories[cat].categoryType}</h3>
          <p class="description">${this.categories[cat].description}</p>
          <a class="component__link button button--one button--small button--${this.urlParams.c === cat ? "primary" : "secondary"}"
            href="${this.getHashURL({category: cat})}"
            data-track-event='${buttonDataTrackEvent}'
          >
            ${this.categories[cat].teamCTA}
          </a>
          ${teamName}
        </div>
      </div>`;
    }
    return categories;
  }

  instructions() {
    var ratingTypes = ``;
    for (var c in this.ratingTypes) {
      ratingTypes += `<div class="column column-md-4 text-center">
        ${this.ratingTypes[c].image}
        <h5 class="no-marg">${this.ratingTypes[c].label}</h5>
        <h2>&ldquo;${this.ratingTypes[c].ratingType}&rdquo;</h2>
      </div>`;
    }
    return ratingTypes;
  }

  share() {
    let dateBits = this.urlParams.td.split('-');
    let dateYear = Number(dateBits[0]);
    let dateMonth = Number(dateBits[1]) - 1;
    let dateDay = Number(dateBits[2]);
    var nextDate = new Date(dateYear, dateMonth, dateDay);
    nextDate.setDate(nextDate.getDate() + 28);

    const copyLinkDataTrackEvent = "Health Monitor - Copy Link";
    const emailDataTrackEvent = "Health Monitor - Email";

    this.additionalTrackingProperties[copyLinkDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
      'label': this.labels.copyLink,
      'eventContainer' : 'share',
      'eventComponent' : 'button',
    }};
    this.additionalTrackingProperties[emailDataTrackEvent] = { ...this.additionalTrackingSchema, ...{
      'label': this.labels.emailLink,
      'eventContainer' : 'share',
      'eventComponent' : 'button',
    }};

    return `<div class="column column-md-6 column-md-offset-3 text-center">
      <div class="block-theme-one share-block">
        <h3>${this.labels.shareResults}</h3>
        <div>
          <input class="copy-this" id="copy-text" value="${window.location.origin + window.location.pathname + this.getHashURL({increment: -1})}">
        </div>
        <a id="copy-link" class="button button--one button--small button--primary" data-track-event="${copyLinkDataTrackEvent}">
          ${this.labels.copyLink}
        </a>
        <a id="email-link" href="mailto:?body=${encodeURIComponent(this.labels.emailBody)}%0D%0D${window.location.origin + window.location.pathname + this.getHashURL({increment: -1})}" class="button button--one button--small button--primary" data-track-event="${emailDataTrackEvent}">
          ${this.labels.emailLink}
        </a>
      </div>
      </div>
      </div>
      <div class="row"><div class="column text-center">

      <h4>${this.labels.scheduleYourNext}</h4>
      <p>${this.labels.yourNextHealthMonitor}</p>

      <h5 class="text-b400">${this.monthMap[nextDate.getMonth()]} ${nextDate.getDate()}, ${nextDate.getFullYear()}</h5>
      </div>
    </div>`;
  }
}
